var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-webuploader-com"},[_vm._t("default",[(!_vm.btnId || _vm.btnId.length === 0)?_c('div',{attrs:{"id":_vm.id}}):_vm._e()])],2)}
var staticRenderFns = []

export { render, staticRenderFns }